import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, map, Observable, throwError } from 'rxjs';

import {
	ApolloQueryError,
	ApolloQueryErrorMapper,
	waitForGQLCompleteQueryOrThrow
} from '@shure/shared/angular/data-access/system-api/core';
import { ILogger } from '@shure/shared/angular/utils/logging';

import { CdmDeviceUiApiService } from '../api';
import { CdmDeviceUiDevice } from '../api/models/cdm-device-ui-device';

import { CdmDeviceUiDeviceQueryGQL } from './graphql/generated/cdm-device-ui.generated';
import { mapCdmDeviceUiDeviceFromSysApi } from './mappers/map-cdm-device-ui-device';

@Injectable()
export class SysApiCdmDeviceUiApiService implements CdmDeviceUiApiService {
	private readonly logger: ILogger;

	constructor(
		logger: ILogger,
		private readonly deviceQuery: CdmDeviceUiDeviceQueryGQL,
		private readonly destroyRef: DestroyRef
	) {
		this.logger = logger.createScopedLogger('SysApiCdmDeviceUiApiService');
	}

	public getDevice$(deviceId: string): Observable<CdmDeviceUiDevice> {
		return this.deviceQuery.watch({ variables: { deviceId }, fetchPolicy: 'cache-first' }).valueChanges.pipe(
			takeUntilDestroyed(this.destroyRef),
			waitForGQLCompleteQueryOrThrow(),
			map((result) => {
				if (result.data?.node && '__typename' in result.data.node) {
					return mapCdmDeviceUiDeviceFromSysApi(result.data.node);
				}

				throw ApolloQueryErrorMapper.getError(result);
			}),
			catchError((error) => {
				this.logger.error('getDevice$()', 'Error fetching device', { deviceId, error });
				return throwError(() => new ApolloQueryError(error));
			})
		);
	}
}
